import { handleHeaderScroll } from './js/base-js/scroll';
import 'basiclightbox/dist/basicLightbox.min.css'
handleHeaderScroll();